export const UPLOAD_IMAGE = {
    START: 'UPLOAD_IMAGE_START',
    SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
    ERROR: 'UPLOAD_IMAGE_ERROR',
  };